import { useState } from "react";
import { Modal, Button as ButtonBootstrap } from "react-bootstrap";
import Maximize from "./Maximize";
import Minimize from "./Minimize";

const ConfirmationModal = (props) => {
  const [fullscreen, setFullscreen] = useState(false);

  const doubleCloseModals = () => {
    props.doubleCloseModals();
  };

  const fullscreenHandler = () => {
    setFullscreen(!fullscreen);
  };

  return (
    <Modal
      show={props.show}
      onHide={props.hide}
      className={!fullscreen && "confirmation-modal"}
      size="xs"
      fullscreen={fullscreen}
    >
      <Modal.Header closeButton style={{ position: "relative" }}>
        <Modal.Title size="h6">Confirmation</Modal.Title>
        <button
          style={{
            position: "absolute",
            right: "40px",
            top:"3px",
            padding: "0 0 1px 0",
            background: "none",
            border: "none",
          }}
          type="button"
          class="btn btn-primary"
          onClick={fullscreenHandler}
        >
          {fullscreen ? <Maximize /> : <Minimize />}
        </button>
      </Modal.Header>
      <Modal.Body>
        <p>
          {props.msg}
        </p>
      </Modal.Body>

      <Modal.Footer>
        <ButtonBootstrap
          variant="primary"
          className="btnPrimary"
          onClick={doubleCloseModals}
        >
          Leave
        </ButtonBootstrap>
        <ButtonBootstrap
          variant="secondary"
          className="btnSecondary"
          onClick={props.hide}
        >
          Stay
        </ButtonBootstrap>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmationModal;